import React from 'react';
import autobind from 'autobind-decorator';

import {UnitNumberFieldEditor} from "../../../../Models/Core/FieldEditors";
import {UnitNumberFieldViewer} from "../../../../Models/Core/FieldViewers";

import {SurveyFormInputEnhance} from "./SurveyFormInputEnhance";

@SurveyFormInputEnhance
export class SurveyFormInputNumber extends React.Component {

    @autobind
    change(value) {
        const { SurveyFormInput } = this.props;

        SurveyFormInput.Change((answer) => {
            const number = Number(value);

            if (value === "") {
                SurveyFormInput.MarkValidationStatusValid();
            } else if (isNaN(number) || (value.indexOf('e') > -1)) {
                SurveyFormInput.SetValidationStatusError("Invalid Number");
            } else {
                SurveyFormInput.MarkValidationStatusValid();
            }

            answer.valueNumeric = value;

            return answer;
        });
    }

    render() {
        const { SurveyFormInput, EditMode } = this.props;

        const answer = SurveyFormInput.GetAnswer();
        const question = SurveyFormInput.GetQuestion();
        const value = answer ? answer.valueNumeric: "";
        const fieldDef = {
            customData: {
                unitId: question.unitId
            }
        };

        if(!EditMode) {
            return <UnitNumberFieldViewer
                Value={value}
                FieldDef={fieldDef}
            />;
        }

        return <UnitNumberFieldEditor
            Value={value}
            FieldDef={fieldDef}
            OnUpdate={(x) => this.change(x)}
        />;
    }
}


